module.exports = __webpack_public_path__ + "static/media/annie.11595b05.png";